export default "__VITE_ASSET__Cp94FlZ7__"